import * as types from "./actionTypes";

export function validatieStatussenLoaded(validatieStatussen) {
	return {
		type: types.VALIDATIESTATUS_LOADED,
		body: validatieStatussen
	};
}